import { Pipe, PipeTransform } from '@angular/core';
import { TrackingData } from '../providers/tracking';

@Pipe({
  name: 'getEventMatch'
})

export class EventMatchPipe implements PipeTransform {

  constructor(
    private tracking: TrackingData
  ) {}

  transform(eventId: string, clientId: string, userId: string): any {
    return this.tracking.findEntityById(clientId, userId, eventId, 'event').map(result => result.data);
  }
}


// WEBPACK FOOTER //
// ./src/pipes/event-ai.pipe.ts